import { render, staticRenderFns } from "./CommonRatingAvatar.vue?vue&type=template&id=374dc71c"
import script from "./CommonRatingAvatar.vue?vue&type=script&lang=js"
export * from "./CommonRatingAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports